<template>
  <svg
    width="20"
    height="13"
    viewBox="0 0 20 13"
  >
    <path d="M0.75 11.4995H19.2487C19.663 11.4995 19.9987 11.8353 19.9987 12.2495C19.9987 12.6292 19.7166 12.943 19.3505 12.9927L19.2487 12.9995H0.75C0.335786 12.9995 0 12.6637 0 12.2495C0 11.8698 0.282154 11.556 0.648229 11.5063L0.75 11.4995H19.2487H0.75ZM16.2494 0C17.2159 0 17.9994 0.783502 17.9994 1.75V9.25029C17.9994 10.2168 17.2159 11.0003 16.2494 11.0003H3.74937C2.78288 11.0003 1.99937 10.2168 1.99937 9.25029V1.75C1.99937 0.783502 2.78288 0 3.74937 0H16.2494ZM16.2494 1.5H3.74937C3.6113 1.5 3.49937 1.61193 3.49937 1.75V9.25029C3.49937 9.38836 3.6113 9.50029 3.74937 9.50029H16.2494C16.3874 9.50029 16.4994 9.38836 16.4994 9.25029V1.75C16.4994 1.61193 16.3874 1.5 16.2494 1.5Z" />
  </svg>
</template>
